import { AppContext } from "../../App";
import { useContext } from "react";
import { NavLink, Link } from 'react-router-dom';
import { React, useState, useEffect } from "react";


//Import FontAwesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faAngleDown, faBars, faXmark } from "@fortawesome/free-solid-svg-icons";
import { faFacebookF, faTiktok, faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";


//Import Css
import './home.css';
import './infoDesarrolloHome.css';
import './sectionMobileDesing.css';
import './sectionWebGoogle.css';
import './sectionEnfoque.css';
import './sectionRediseno.css';
import './sectionSoporteEmpresas.css';

//Import Swiper React components
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';


//Import Assets
import LogoWebmedia from '../../assets/homeAssets/logoWebMedia.svg'


//Import Components
import { SocialMediaComponents } from '../socialMediaComponents/socialMediaComponents'
import { InfoDevelopComponent } from '../home/infoDevelopComponent/infoDevelopComponent'
import { ButtonEnfoqueComponent } from '../home/buttonEnfoqueComponent'
import { FooterComponent } from '../footerComponent/footerComponent'
import { PopUpEnfoque } from '../home/popUpEnfoque/popUpEnfoque'
import { BarraMenuDown } from '../home/barraMenuDown'
import { PanelMenuSlide } from '../home/panelMenuSlide'
import { CarSoportEmpCompt } from './cardSoportEmpCompt'
import { PlanesCompt } from '../developComponent/planesCompt/planesCompt'

export function Home() {


//State para las cards info desarrollo
const [activeCard, setActiveCard] = useState(1);


    const { 

        //State Barra Menu Down 
        visible,
        setVisible,
        //Menu Mobile Slide
        panelIsOpen,
        setPanelIsOpen,
        //Iconos Mobile Desing
        IconDesktop,
        IconTablets,
        IconMobile,
        IconMDIos,
        IconMDGoogle,
        IconMDMicrosoft,
        IconMDAndroid,
        //Iconos Enfoque
        IconEnfoqueDinamico,
        IconEnfoqueFuncional,
        IconEnfoqueProductivo,
        IconEnfoqueHand,
        //Iconos Web Google
        IconAnalytics,
        IconADS,
        IconMaps,
        //Iconos Web Rediseno
        IconActualizacion,
        IconRediseno,
        IconSeoIA,
        IconWordPress,
        IconShopify,
        IconWix,
        IconJoomla,
        //Iconos Soporte
        IconArrowNext,  
        // State popUp Enfoque
        // PopUpAssets
        photoDinamico,
        photoFuncional,
        photoComercial,
        textPopUp,
        titlePopUp,
        valorPopUp
 


    } = useContext(AppContext);


    return(

        <div className="container-all-component-home" translate="no">


            <BarraMenuDown />

            {/* --------- BOTON MENU SLIDE ----------- */}
            <div className='box-menu-mobile-home'>

                <button
                    className="btn-menu-slide"
                    onClick={() => setPanelIsOpen(!panelIsOpen)}>
                        {panelIsOpen ? (
                            <span id="btn-close-slide-menu" className="material-symbols-outlined">close</span>
                        ) : (
                            <span id="btn-open-slide-menu" className="material-symbols-outlined">menu</span>
                        )}

                </button>

            </div>

            <PanelMenuSlide />


            {/* --------- PORTADA TOP HOME WEBMEDIA ----------- */}
            <div className="container-portada-home">

               <div className="box-logo-portada-home">

                    <img className='logo-webmedia-portada-home' src={LogoWebmedia} alt="Logo WebMedia"/>

               </div>

                
                <nav className="conteiner-links-home">
                    <NavLink to='/desarrollo-web'         className={`home-menu-link slide-link-1`}>Desarrollo Web</NavLink>
                    <NavLink to='/google-ads'            className={`home-menu-link slide-link-2`}>Google ADS</NavLink>
                    <NavLink to='/email-marketing'       className={`home-menu-link slide-link-3`}>Email Marketing</NavLink>
                    <NavLink to='/soporte-empresas'      className={`home-menu-link slide-link-4`}>Soporte Empresas</NavLink>
                    <NavLink to='/contacto'              className={`home-menu-link slide-link-4`}>Contacto   </NavLink>

                </nav>
        
                <div className="box-social-media-home"> <SocialMediaComponents /> </div>

            </div>


            {/* --------- SECTION INFO DESARROLLO ----------- */}

            <div className="container-info-desarrollo">

                <div className="box-info-desarrollo">

                    <div className="box-text-info">

                        <div className="container-car-info">

                            <div className={`box-card-Info ${activeCard === 1 ? "Box-Card-2" : "Box-Card-1"}`}>

                                <InfoDevelopComponent 
                                    titleInfoDevelop={ <> DESARROLLO WEB <br /> PROFESIONAL </> }
                                    textInfoDevelop='Desarrollamos sitios webs corporativos con lenguajes de programación nativos 100% responsivos a todos los dispositivos móviles y navegadores webs modernos.'
                                    photIconDev={[0,1,2,3]} />

                            </div>

                            <div className={`box-card-Info ${activeCard === 2 ? "Box-Card-2" : activeCard < 2 ? "Box-Card-3" : "Box-Card-1"}`}>

                                <InfoDevelopComponent 
                                    titleInfoDevelop={ <> SEO CON IA Y <br /> MOTORES DE BÚSQUEDA </> }
                                    textInfoDevelop='Optimizamos el contenido e información de su web en motores de búsqueda y modelos IA para maximizar oportunidades de venta y recomendación.'
                                     photIconDev={[4,5,6,7]} />
                            
                            </div>

                            <div className={`box-card-Info ${activeCard === 3 ? "Box-Card-2" : "Box-Card-3"}`}>

                                <InfoDevelopComponent 
                                    titleInfoDevelop={ <> REDISEÑO <br /> Y ACTUALIZACIÓN </> }
                                    textInfoDevelop='Rediseñamos o actualizamos su sitio actual con los últimos estándares de la WEB, navegación móvil, SEO y canales digitales.'
                                    photIconDev={[8,9,10,11]} />

                            </div>

                        </div>

                        <div className="box-btn-info-desarrollo">
                        <button
                            className={`btn-move-info btn-A ${activeCard === 1 ? "active" : ""}`}
                            onClick={() => setActiveCard(1)}
                        ></button>

                        <button
                            className={`btn-move-info btn-B ${activeCard === 2 ? "active" : ""}`}
                            onClick={() => setActiveCard(2)}
                        ></button>

                        <button
                            className={`btn-move-info btn-C ${activeCard === 3 ? "active" : ""}`}
                            onClick={ () => setActiveCard(3)}
                        ></button>
                        </div>


                    </div> 

                        {/* Foto BackgroundImagen  */}
                    <div className="box-photo-info"></div>

                </div>

            </div>


            {/* --------- SECTION WEB MOBILE ----------- */}
            <div className="container-web-mobile">

                    <div className="box-title-text-web-mobile"> 
                        <h2 className="title-web-mobile">WEB & MOBILE RESPONSIVE DESIGN</h2>
                        <p className="text-title-web-mobile">
                            Desarrollamos su sitio web con la capacidad 
                            de adaptarse a todas las pantallas móviles 
                            modernas de forma nativa y fluida.
                        </p>
                    </div>


                    {/* ---- Box Iconos Desing Mobile */}
                    <div className="box-icon-mobile-desing">

                        <img className="icon-mobile-desing iconMD-A" alt="Diseño Desktop" src={IconDesktop}/> 
                        <img className="icon-mobile-desing iconMD-B" alt="Diseño Tablets" src={IconTablets}/> 
                        <img className="icon-mobile-desing iconMD-C" alt="Diseño Mobile" src={IconMobile}/> 

                    </div>

                    {/* ---- Box Iconos Marcas Os */}
                    <div className="box-icon-marca-Os">

                        <img className="icon-marca-Os iconOs" alt="Diseño Ios" src={IconMDIos}/> 
                        <img className="icon-marca-Os iconOs" alt="Diseño Chrome" src={IconMDGoogle}/> 
                        <img className="icon-marca-Os iconOs" alt="Diseño Window" src={IconMDMicrosoft}/> 
                        <img className="icon-marca-Os iconOs" alt="Diseño Android" src={IconMDAndroid}/> 

                    </div>

            </div>


            {/* --------- SECCIÓN ENFOQUE ----------- */}
            <div className='conteiner-section-enfoque'>

                <div className='box-title-text'>
                    <h2 className="title-enfoque">INSPIRACIÓN EN CADA PROYECTO</h2>
                    <p className="text-title-enfoque">
                        Planificamos, diseñamos y estructuramos su sitio web con un enfoque dinámico, 
                        funcional y productivo. Obtenga el mejor posicionamiento con la mayor tasa de 
                        conversión posible.
                    </p>
                </div>

                <div className="container-btn-enfoque">

                        <ButtonEnfoqueComponent
                            classNameButton='dinamico'
                            iconEnfoque={ IconEnfoqueDinamico}
                            textButton={<> ENFOQUE <br/> DINÁMICO</>}
                            IconHand={IconEnfoqueHand}
                            ValorPopUp={1}

                        />


                        <ButtonEnfoqueComponent
                            classNameButton='funcional'
                            iconEnfoque={ IconEnfoqueFuncional}
                            textButton={<> ENFOQUE <br/> FUNCIONAL</>}
                            IconHand={IconEnfoqueHand}
                            ValorPopUp={2}

                        />

                        
                        <ButtonEnfoqueComponent
                            classNameButton='comercial'
                            iconEnfoque={ IconEnfoqueProductivo}
                            textButton={<> ENFOQUE <br/> COMERCIAL</>}
                            IconHand={IconEnfoqueHand}
                            ValorPopUp={3}

                        />

                </div>


                <div className="contenedor-popUp"> 
                        
                    {valorPopUp === 1 &&     
                    
                        <PopUpEnfoque 
                        
                            photoPopUp={photoDinamico}
                            titlePopUp={titlePopUp[0]}
                            iconPopUp={IconEnfoqueDinamico}
                            textPopUp={textPopUp[0]}
                            textClassName='filter-bk1'
                        
                        />
                    
                    }


                    {valorPopUp === 2 &&     
                    
                        <PopUpEnfoque 
                        
                            photoPopUp={photoFuncional}
                            titlePopUp={titlePopUp[1]}
                            iconPopUp={IconEnfoqueFuncional}
                            textPopUp={textPopUp[1]}
                            textClassName='filter-bk2'
                     
                        />
                    
                    }

                
                    {valorPopUp === 3 &&     
                    
                        <PopUpEnfoque 
                        
                            photoPopUp={photoComercial}
                            titlePopUp={titlePopUp[2]}
                            iconPopUp={IconEnfoqueProductivo}
                            textPopUp={textPopUp[2]}
                            textClassName='filter-bk3'
                    
                        />
                    
                    }

                </div>


            </div>

            {/* --------- SECCIÓN SU WEB EN GOOGLE ----------- */}
            <div className="conteiner-web-google">

                <div className='box-info-web-google'>

                        <div className="box-title-text-web-google">
                            <h2 className="title-web-google">SU WEB EN GOOGLE</h2>
                            <h3 className="sub-title-web-google">Optimizamos su sitio para motores de búsqueda y modelos IA</h3>
                            <p className="text-web-google"> 
                                Todo el contenido e información de sus productos, servicios, ubicaciones 
                                y canales de información será registrado e indexado en las principales 
                                herramientas de posicionamiento y búsqueda de Google. 
                            </p>
                        </div>

                        <div className="box-icon-web-google">

                                <img className="icon-web-google iconWG-A" alt="Google Analitys, ADS, Maps" src={IconAnalytics}/> 
                                <img className="icon-web-google iconWG-B" alt="Google Analitys, ADS, Maps" src={IconADS}/> 
                                <img className="icon-web-google iconWG-C" alt="Google Analitys, ADS, Maps" src={IconMaps}/> 

                        </div> 

                </div>

                <div className='box-photo-web-google'></div>

                
            </div>

            {/* --------- SECCIÓN REDISEÑO ----------- */}
            <div className="conteiner-redineno"> 


                <div className="box-title-rediseno">
                    <h2 className='title-rediseno'>ACTUALIZAMOS O REDISEÑAMOS SU WEB CON ESTÁNDARES ACTUALES</h2>
                </div>

                <div className="box-blocks-rediseno">

                    {/* BLOQUE A - ACTUALIZACIÓN */}
                    <div className="block-rediseno block-rd-A">

                        <div className="box-icon-title">
                            <img className="icon-rediseno icon-rd-A" src={IconActualizacion}></img>
                            <h3 className="title-rediseno title-rd-A">Actualización</h3>
                        </div>

                        <div className="box-text-rediseno">
                            <p className="text-rediseno text-rd-A">
                                Actualizamos la información de su sitio web creado en Wordpress, 
                                Wix, Joomla o cualquier CMS
                            </p>
                        </div>

                    </div>


                    {/* Linea divisoria */}
                    <div className="line-divisor-blocks"></div>


                    {/* BLOQUE B - ACTUALIZACIÓN */}
                    <div className="block-rediseno block-rd-B">

                        <div className="box-icon-title">
                            <img className="icon-rediseno icon-rd-B" src={IconRediseno}></img>
                            <h3 className="title-rediseno title-rd-B">Rediseño</h3>
                        </div>

                        <div className="box-text-rediseno">
                            <p className="text-rediseno text-rd-B">
                                Tomamos toda la información de su sitio actual para rediseñarlo y 
                                modernizarlo acorde a las especificaciones actuales de la web.
                            </p>
                        </div>

                    </div>


                    {/* Linea divisoria */}
                    <div className="line-divisor-blocks"></div>


                    {/* BLOQUE C - ACTUALIZACIÓN */}
                    <div className="block-rediseno block-rd-C">

                        <div className="box-icon-title">
                            <img className="icon-rediseno icon-rd-C" src={IconSeoIA}></img>
                            <h3 className="title-rediseno title-rd-C">Seo con IA</h3>
                        </div>

                        <div className="box-text-rediseno">
                            <p className="text-rediseno text-rd-C">
                                Optimizamos el posicionamiento y reconocimiento de su sitio web en 
                                Gemini de Google para mayores oportunidades recomendación del modelo.
                            </p>
                        </div>

                    </div>

                </div>


                <div className="box-icon-brands-rediseno">

                        <img className="icon-brand-rd iconWordPress" alt="WordPress" src={IconWordPress}/> 
                        <img className="icon-brand-rd iconshoppify"  alt="Shoppify"  src={IconShopify}/> 
                        <img className="icon-brand-rd iconWix"       alt="Wix"       src={IconWix}/> 
                        <img className="icon-brand-rd iconJoomla"    alt="Joomla"    src={IconJoomla}/> 

                </div>

            </div> 
                
            {/* --------- SECCIÓN SOPORTE EMPRESAS ----------- */}
            <div className="conteiner-soporte-empresa">
                
                    <div className="box-title-text-soporte-empresa">
                        <h2 className="title-soporte-empresas">SOPORTE EMPRESAS</h2>
                        <p className="text-soporte-empresas">
                            Soporte y asesoramiento en servicios digitales, instalación de software, 
                            configuración de sistemas operativos y bases de datos.
                        </p>
                    </div>
                
                        <CarSoportEmpCompt />

                    <Link to="./soporte-empresas" className="box-link-conoce-mas">

                            <p className="text-btn-conoce-mas">Conoce Más</p>
                            <img className="icono-next-conoce-mas" src={IconArrowNext} alt="botón siguiente"/>
                    </Link>


            </div>

            {/* SECTION PLANES PRECIOS */}
            <div className="box-content-planes-precios">

                    <PlanesCompt />

            </div>
                            
                            <FooterComponent />


        </div> 


    )
}